<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconRemoteControl_24"
>
    <path
        d="M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1Zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2ZM7.05 6.05l1.41 1.41a5.022 5.022 0 0 1 7.08 0l1.41-1.41A6.976 6.976 0 0 0 12 4c-1.93 0-3.68.78-4.95 2.05ZM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41A9.011 9.011 0 0 1 12 2c2.49 0 4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0Z"
        fill="currentColor"
    />
</svg>
